import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ProductItems } from 'app/models/product/get-product-request';

@Component({
  selector: 'product-table-view',
  templateUrl: './table-view.component.html',
  styleUrl: './table-view.component.scss',
})
export class ProductTableViewComponent {
  @Input() productRowsPerPage: number = 10;
  @Input() productItems = new Array<ProductItems>();
  @Input() productRowsPerPageOptions!: Array<number>;
  @Input() productTotalRecords: number = -1;
  @Input() productPageIndex = 0;

  @Output() loadProducts = new EventEmitter<PageEvent>();
  @Output() showViewProductSidebarEmit = new EventEmitter<boolean>();
  @Output() viewProductDialog = new EventEmitter<ProductItems>();
  @Output() editProductDialog = new EventEmitter<ProductItems>();

  public productCols: any[] = [
    { field: 'Name', header: 'Product Name', width: '20%' },
    { field: 'ParentCategoryName', header: 'Category', width: '20%' },
    {
      field: 'CategoryName',
      header: 'Sub Category',
      width: '20%',
      disableSort: true,
    },
    { field: 'UOM', header: 'UOM', width: '20%', disableSort: true },
    { field: 'Units', header: 'Units', width: '20%' },
    { field: 'PublishedPrice', header: 'Price', width: '20%' },
    { field: 'IsEnable', header: 'Status', width: '20%' }
  ];

  displayedColumns: string[] = [
    'Name',
    'CategoryId',
    'SubCategoryId',
    'UOM',
    'Units',
    'PublishedPrice',
  ];

  handleProductLazyLoadTable(event: PageEvent) {
    this.loadProducts.emit(event);
  }

  viewProductDetails(product: ProductItems){
    this.viewProductDialog.emit(product);
  }

  editProduct(product: ProductItems){
    this.editProductDialog.emit(product);
  }
}
